import Plot from "react-plotly.js";

export default function SpectrumPlot({ x, y1, y2 }) {
    return (
        <Plot
            className="Plot"
            data={[
                {
                    x: x,
                    y: y1,
                    color: "#4C566A",
                    fill: "tozeroy",
                    fillpattern: { shape: "/" },
                    name: "Raw Raman Spectrum",
                    mode: "lines",
                    line: {
                        color: "#4C566A"
                    }
                },
                {
                    x: x,
                    y: y2,
                    fill: "tozeroy",
                    name: "Baseline Corrected Spectrum",
                    mode: "lines",
                    line: {
                        color: "#ff7043"
                    }
                },
            ]}
            config={{ responsive: true, staticPlot: true }}
            layout={{
                paper_bgcolor: "#00000000",
                plot_bgcolor: "#00000000",
                legend: {
                    x: 0.0,
                    y: 1.0,
                },
                showlegend: true,
                xaxis: {
                    visible: true,
                    showgrid: false,
                    zeroline: false,
                    title: "Raman Shift",
                },
                yaxis: { visible: false },
                margin: {
                    l: 0,
                    r: 0,
                    b: 50,
                    t: 50,
                    pad: 0,
                },
                title: "Raman Spectrum",
                font: {
                    family: "Sans-Serif",
                    size: 18,
                    color: "#7f7f7f",
                },
            }}
        ></Plot>
    );
}
